/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

function getTimeParts(
  timeInSeconds: number,
  forceIncludeHours: boolean = false
): number[] {
  const hours = Math.floor(timeInSeconds / 3600);
  const minutes = Math.floor((timeInSeconds - hours * 3600) / 60);
  const seconds = Math.floor((timeInSeconds - hours * 3600) % 60);

  if (hours || forceIncludeHours) {
    return [hours, minutes, seconds];
  } else {
    return [minutes, seconds];
  }
}

export function formatSeconds(
  timeInSeconds: number,
  forceIncludeHours = false
): string {
  return getTimeParts(timeInSeconds, forceIncludeHours)
    .map((value: number, index: number): string =>
      index != 0 && value < 10 ? `0${value}` : String(value)
    )
    .join(":");
}

export function formatSecondsMatching(
  timeInSeconds: number,
  matchingTimeInSeconds: number
): string {
  return formatSeconds(timeInSeconds, matchingTimeInSeconds >= 3600);
}

export function millisecondsToSeconds(milliseconds: number, fixed = 3): number {
  return parseFloat((milliseconds / 1000.0).toFixed(fixed));
}

export function secondsToMilliseconds(seconds: number): number {
  return Math.round(seconds * 1000);
}

export function msToFullMinutes(ms: number): number {
  return Math.floor(ms / 1000 / 60);
}
